interface GiftTextModalProps {
  isOpen: boolean;
  value: string;
  onChange: (value: string) => void;
  onSave: () => void;
  onCancel: () => void;
}

export const GiftTextModal = ({
  isOpen,
  value,
  onChange,
  onSave,
  onCancel,
}: GiftTextModalProps) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-gray-800 rounded-lg p-6 max-w-md w-full">
        <h2 className="text-white text-xl mb-4">
          Введите текст / Enter text:
        </h2>
        <textarea
          className="w-full p-3 rounded bg-gray-700 text-white border border-gray-600 focus:outline-none focus:border-blue-500"
          rows={4}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Введите текст для подарка / Enter gift text"
          autoFocus
        />
        <div className="flex gap-3 mt-4">
          <button
            onClick={onSave}
            className="flex-1 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded transition-colors"
          >
            Сохранить / Save
          </button>
          <button
            onClick={onCancel}
            className="flex-1 bg-gray-600 hover:bg-gray-700 text-white px-4 py-2 rounded transition-colors"
          >
            Отмена / Cancel
          </button>
        </div>
      </div>
    </div>
  );
};
